<template>
    <v-container fluid>
        <v-row no-gutters class="d-flex justify-center">
            <!-- <v-col cols="8" class="headline font-weight-bold pb-2">
                <span style="font-weight: bold; font-size: 24pt;">
                    Lettres de mission
                </span>
            </v-col> -->
            <v-col cols="2">
                <v-btn-primary
                    block
                    height="40px"
                    elevation="0"
                    class="rounded-lg gradient"
                    @click="$router.push({ name: 'new-engagement-letter' })"
                    data-cy="EngagementLetters-add"
                >
                    Ajouter
                </v-btn-primary>
            </v-col>
            <v-col cols="2" class="pl-2">
                <v-select
                    v-model="selectedStatus"
                    :items="status"
                    item-title="text"
                    item-value="value"
                    label="Filtrer par statut"
                    hide-details
                    data-cy="EngagementLetters-statut"
                    density="compact"
                />
            </v-col>
            <v-col cols="4" class="pl-2">
                <v-text-field
                    v-model="search"
                    label="Recherche"
                    hide-details
                    data-cy="EngagementLetters-search"
                    density="compact"
                    append-inner-icon="$fa-search"
                    clearable
                    @click:clear="search = ''"
                />
            </v-col>
            <v-col cols="1" class="pl-2" v-if="!$vuetify.display.mobile">
                <TutorialButtonDialog :starterComponents="'EngagementLetters;'">
                </TutorialButtonDialog>
            </v-col>
        </v-row>
        <v-row
            no-gutters
            class="d-flex justify-center"
            :style="'max-height:' + maxHeight + ';' + 'overflow:auto'"
        >
            <v-col class="py-2" cols="8" v-for="(item, index) in engagementLetters" :key="index">
                <v-card>
                    <v-card-item
                        class="d-flex align-center justify-space-between position-relative"
                    >
                        <template #prepend>
                            <v-row no-gutters class="px-2 d-flex align-center">
                                <v-col cols="auto" class="d-flex align-center">
                                    <v-icon
                                        icon="$oss-letter"
                                        @click="setRouter(item.id)"
                                        class="mr-2"
                                        color="primary"
                                        size="36"
                                    />
                                </v-col>
                                <v-col class="d-flex flex-column justify-center">
                                    <div
                                        class="primary--text"
                                        style="white-space: nowrap"
                                        @click="setRouter(item.id)"
                                    >
                                        {{ getTitle(item) }}
                                    </div>
                                    <div>
                                        <v-icon
                                            size="small"
                                            location="start"
                                            class="mr-1"
                                            @click="setRouter(item.id)"
                                        >
                                            $oss-outlined-user
                                        </v-icon>
                                        {{ getAccountant(item) }}
                                    </div>
                                </v-col>
                            </v-row>
                        </template>
                        <template #default>
                            <v-row no-gutters class="d-flex position-absolute" style="left: 45%">
                                <v-col
                                    cols="auto"
                                    class="d-flex align-center justify-center"
                                    style="white-space: nowrap"
                                >
                                    <v-icon size="small" color="primary" class="mr-1">
                                        $oss-calendar
                                    </v-icon>
                                    <span
                                        @click="setRouter(item.id)"
                                        class="text-overline font-text-statut"
                                        :data-cy="`EngagementLetters-statut-${item.id}`"
                                    >
                                        {{ $t("engagementLetter.status." + item.status) }}
                                    </span>
                                </v-col>
                            </v-row>
                        </template>

                        <template #append>
                            <v-row
                                class="d-flex justify-center py-2"
                                v-if="!$vuetify.display.mobile"
                            >
                                <v-col cols="10" class="pt-1 pb-1" style="width: 100px">
                                    <v-btn
                                        block
                                        size="small"
                                        @click="setRouter(item.id)"
                                        :data-cy="`EngagementLetters-edit-${item.id}`"
                                    >
                                        {{ item.status === "DRAFT" ? "Editer" : "Accéder" }}
                                    </v-btn>
                                </v-col>
                                <v-col cols="10" class="pt-1 pb-1">
                                    <v-btn
                                        v-if="item.status !== 'SIGNED'"
                                        variant="outlined"
                                        block
                                        color="error"
                                        @click.stop="confirmDeleteEngagementLetter(item)"
                                        size="small"
                                        style="min-width: 100%"
                                    >
                                        Supprimer
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card-item>
                </v-card>
            </v-col>
            <oss-dialog
                v-model="deleteDialog"
                title="Supprimer une lettre de mission"
                @valid="deleteEngagementLetter()"
                valid-title="Confirmer"
                width="40vw"
            >
                <!-- <v-toolbar  color="primary">
                        <v-toolbar-title>Supprimer une lettre de mission</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="deleteDialog = false">
                            <v-icon>$close</v-icon>
                        </v-btn>
                    </v-toolbar> -->

                <div class="px-2">&#xca;tes-vous sur de supprimer la lettre de mission ?</div>

                <!-- <v-card-text>
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex justify-end">
                                <v-btn
                                    rounded
                                    outlined
                                    color="secondary"
                                    class="mr-1"
                                     size="small"
                                    @click="deleteDialog = false"
                                >
                                    Annuler
                                </v-btn>
                                <v-btn
                                    rounded
                                    color="secondary"
                                    class="ml-1"
                                     size="small"
                                    elevation="0"
                                    @click="deleteEngagementLetter()"
                                >
                                    Confirmer
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text> -->
            </oss-dialog>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import TutorialButtonDialog from "../tutorial/TutorialButtonDialog.vue";

import ENGAGEMENT_LETTERS from "../../graphql/engagementLetter/EngagementLetters.gql";
import DELETE_ENGAGEMENT_LETTER from "../../graphql/engagementLetter/DeleteEngagementLetter.gql";

import { Apollo } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        TutorialButtonDialog,
    },
})
export class EngagementLetters extends Vue {
    deleteDialog = false;

    toDeleteId = "";

    selectedStatus = null;

    search = "";

    get status() {
        return [
            { text: "Tous", value: null },
            { text: "Signé", value: "SIGNED" },
            { text: "Validé", value: "VALIDATED" },
            { text: "En cours d'édition", value: "DRAFT" },
        ];
    }

    get companyId() {
        return this.$store.state.user.company.id;
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (170 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    @Apollo({
        query: ENGAGEMENT_LETTERS,
        variables() {
            return {
                companyId: this.companyId,
                status: this.selectedStatus ? this.selectedStatus : undefined,
                q: this.search ? this.search : undefined,
            };
        },
    })
    engagementLetters = [];

    getTitle(item) {
        debugger;
        if (item?.prospectedCompany?.name) {
            return item.prospectedCompany.name;
        }
        if (
            item?.data?.prospectedClient &&
            item?.data?.prospectedClient?.lastname &&
            item?.data?.prospectedClient?.firstname
        ) {
            return item.data.prospectedClient.firstname + " " + item.data.prospectedClient.lastname;
        }
        return item.data.accountant.firstname + " " + item.data.accountant.lastname;
    }

    getAccountant(item) {
        return item.accountant.firstname + " " + item.accountant.lastname;
    }

    setRouter(id) {
        this.$router.push({
            name: "engagement-letter",
            params: {
                id: id,
            },
        });
    }

    confirmDeleteEngagementLetter(item) {
        this.toDeleteId = item.id;
        this.deleteDialog = true;
    }

    async deleteEngagementLetter() {
        await this.$apollo.mutate({
            mutation: DELETE_ENGAGEMENT_LETTER,
            variables: {
                id: this.toDeleteId,
            },
        });
        this.deleteDialog = false;
        this.engagementLetters = this.engagementLetters.filter((x) => x.id !== this.toDeleteId);
    }
}

export default toNative(EngagementLetters);
</script>
<style scoped>
.font-text-statut {
    font-family: Poppins !important;
}
</style>
